module.exports = __webpack_public_path__ + "img/Menu-07.b89f9f17.png";